import { Helmet } from "react-helmet-async"
import React, { useEffect } from "react"
import { Container, createStyles, TypographyStylesProvider, Box } from "@mantine/core"
import { PageTitle } from "../../shared/ui/PageTitle"
import { AboutStore } from "../../app/store"
import { ResultWrapper } from "../../entities/resultWrapper"
import { observer } from "mobx-react-lite"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  textContent: {
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
}))

// ----------------------------------------------------------------------

export const AboutOrganizationPage = observer(function AboutOrganizationPage() {
  const { classes } = useStyles()
  const { data, isLoading, error, loadData } = AboutStore
  const url = new URL(window.location.href)

  useEffect(() => {
    void loadData("aboutOrganization")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>
          Об организации
        </title>
        <meta property="og:title" content="Об организации"/>

        <meta name="description"
              content="Информация об образовательной организации Body Coach"/>
        <meta property="og:description"
              content="Информация об образовательной организации Body Coach"/>

        <meta property="og:url" content={url.href}/>
        <link rel="canonical" href={url.href}/>
        <meta property="og:site_name" content={url.host}/>
        <meta name="robots" content="index, follow"/>

        <meta name="keywords"
              content="боди коуч документы, о боди коуч, о body coach, документы body coach"/>
      </Helmet>

      <Container size="lg" className={classes.container}>
        <PageTitle title="Информация об образовательной организации"/>

        <ResultWrapper
          isEmpty={false}
          error={error}
          isLoading={isLoading}
        >
          {data && <TypographyStylesProvider mt="xl">
            <Box className={classes.textContent} dangerouslySetInnerHTML={{ __html: data.textContent }}/>
          </TypographyStylesProvider>}
        </ResultWrapper>
      </Container>
    </>
  )
})
